module.exports = __webpack_public_path__ + "img/loading.c6986019.gif";